import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { HandleAjaxError, ShowErrorFlag } from '@helpcenter/flags';
import { handleAjaxError, showErrorFlag } from '@helpcenter/flags';
import { removeOrganisation } from 'rest/participants';
import { REMOVE_ORGANISATION, removeOrganisationSuccess } from 'state/actions/request-details';
import type { RemoveOrganisation, RemoveOrganisationSuccess } from 'state/actions/request-details';
import messages from './messages';

export const removeOrganisationEpic: Epic<
    RemoveOrganisation,
    RemoveOrganisationSuccess | HandleAjaxError | ShowErrorFlag
> = (action$) => {
    return action$.ofType(REMOVE_ORGANISATION).mergeMap((removeParticipantAction) => {
        const { requestKey, organisationId } = removeParticipantAction.payload;

        return removeOrganisation(requestKey, organisationId)
            .map(() => {
                return removeOrganisationSuccess(requestKey, organisationId);
            })
            .catch((error: AjaxError) => {
                const isPermissionDenied = error.status === 403;
                return Observable.of(
                    isPermissionDenied
                        ? showErrorFlag(messages.permissionDeniedErrorTitle, messages.permissionDeniedErrorDescription)
                        : handleAjaxError(error)
                );
            });
    });
};
